import * as Sentry from '@sentry/browser'

let headerSentry: Sentry.Hub
let headerAppRelease: string

export const setHeaderSentry = (incomingHeaderSentry: Sentry.Hub): void => {
  headerSentry = incomingHeaderSentry?.getClient() ? incomingHeaderSentry : undefined
  headerAppRelease = window?.Application?.headerAppRelease
}

export const getHeaderSentry = (): [Sentry.Hub, string] => [headerSentry, headerAppRelease]
